import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * Celebration Store
 *
 * This store manages the state and actions related to celebrations.
 */
export const useCelebrationStore = defineStore("celebration", () => {
  // Refs
  const celebrationVisible = ref(false);
  const celebrationType = ref("confetti");

  // Actions
  /**
   * Show the celebration for a specified duration.
   * * @param {string} [type="confetti"|"clipboard"] - The type of celebration to show.
   * @param {number} [duration] - The duration to show the celebration in milliseconds.
   */
  const showCelebration = (type = "confetti", duration) => {
    celebrationVisible.value = true;
    celebrationType.value = type;

    // Set defaults
    let timeDuration = type === "confetti" ? 10000 : 3500;

    // Overwrite defaults if duration is set
    if (duration) {
      timeDuration = duration;
    }

    setTimeout(() => {
      celebrationVisible.value = false;
    }, timeDuration);
  };

  /**
   * Hide the celebration immediately.
   */
  const hideCelebration = () => {
    celebrationVisible.value = false;
  };

  return {
    showCelebration,
    hideCelebration,
    celebrationVisible,
    celebrationType,
  };
});
